import { T } from '@common/hooks/useTranslation';

export const CUSTOM_VIDEO_QUESTION_MAX_LENGTH = 120;

/**
 * Generates validation rules for the custom video question field.
 * @param t - The translation function.
 * @returns The validation rules object.
 */
export function customVideoQuestionRules(t: T) {
  return {
    validate: (value: string) => {
      if (!value) {
        return t('validations.job.videoScreeningQuestions.required');
      }

      if (value.length > CUSTOM_VIDEO_QUESTION_MAX_LENGTH) {
        return t('validations.job.videoScreeningQuestions.maxLength', {
          max: CUSTOM_VIDEO_QUESTION_MAX_LENGTH
        });
      }

      return;
    }
  };
}
